import { SxProps, Theme, alpha } from "@mui/material";

export const offerCardSx: SxProps<Theme> = {
  p: 2,
  border: 1,
  borderColor: "divider",
  borderRadius: 1,
};

// A tint of the primary colour, not `primary.light`: in this theme that token is a mid blue meant for
// filled selected states with `primary.contrastText`, and the card keeps its dark text.
export const acceptedOfferCardSx: SxProps<Theme> = {
  ...offerCardSx,
  borderColor: "primary.main",
  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
};
